import store from '~/store';
import Big from 'big.js';
export const currencyFilter = (val, coin) => {
  const allCoin = store.state.trade.allCoin; // 所有交易对对象
  if (val * 1 !== 0.00 && allCoin[coin]) {
    return Big(Number(val)).times(Number(allCoin[coin])).valueOf();
  }
}